/// <amd-module name="TFS/Admin/Groups/Common/Redux/DataSource/ProjectScopedUsersDataSource" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

const projectScopedUsersDataProvider = "ms.vss-admin-web.org-admin-project-scoped-users-data-provider";

export async function isCollectionNavigationAllowed(pageContext: IVssPageContext, requestParameters?: { [key: string]: any }): Promise<boolean> {
    const contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");
    const result = await contributionService.getDataAsync<boolean>(projectScopedUsersDataProvider, requestParameters, true);
    return !!result;
}
